var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-life-experience-pavilion',{ref:"table",staticClass:"pt-life-experience-pavilion__withData",on:{"deleteLifeExperienceHallsList":_vm.deleteLifeExperienceHallsList}})}
var staticRenderFns = []

export { render, staticRenderFns }